import React from "react";
import type { TFunction } from "i18next";
import { ResourceEnum } from "src/constants/constants.ts";
import type { Module } from "src/system/module.types.ts";
import type { PaymentMethodResource } from "@exonn/js-sdk";

export const module: Module<PaymentMethodResource> = {
  id: ResourceEnum.PaymentMethod,
  bigIcon: <span className={"icon-20-pay_metd"} />,
  smallIcon: <span className={"icon-15-pay_metd"} />,
  name: (t: TFunction) => t("moduleName.paymentMethods"),

  tabs: {
    edit: {
      getTitle: (resource) => resource.title,
    },
  },
};
